import api from './api';


export const createBatchSubscriptions = async (data) => {
  try {
      const response = await api.post('subscription/batch', data);
      return response.data;
  } catch (error) {
      console.error("Erro ao criar assinaturas em lote:", error);
      throw error;
  }
};


/**
 * Busca o sumário completo de todas as assinaturas para a página de listagem.
 */
export const getSubscriptionSummary = async () => {
  try {
    const response = await api.get('subscription/summary');
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar o sumário de assinaturas:", error);
    return null;
  }
};

/**
 * Busca os detalhes completos de uma única assinatura pelo ID.
 * @param {number} id - O ID da assinatura.
 */
export const getSubscriptionDetails = async (id) => {
  try {
    const response = await api.get(`subscription/${id}/details`);
    return response.data;
  } catch (error)
  {
    console.error("Erro ao buscar os detalhes da assinatura:", error);
    return null;
  }
};

/**
 * Atualiza os dados de uma assinatura.
 * @param {number} id - O ID da assinatura a ser atualizada.
 * @param {object} subscriptionData - Os dados atualizados da assinatura.
 */
export const updateSubscription = async (id, subscriptionData) => {
  try {
    const response = await api.put(`subscription/${id}`, subscriptionData);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar a assinatura:", error);
    throw error;
  }
};

// NOVA FUNÇÃO PARA RENOVAR
/**
 * Renova uma assinatura, atualizando a data de expiração e recursos.
 * @param {number} id - O ID da assinatura.
 */
export const renewSubscription = async (id) => {
  try {
    const response = await api.post(`subscription/${id}/renew`);
    return response.data;
  } catch (error) {
    console.error("Erro ao renovar a assinatura:", error);
    throw error;
  }
};

// NOVA FUNÇÃO PARA BUSCAR TIPOS DE PLANOS
/**
 * Busca todos os tipos de assinatura disponíveis.
 */
export const getAllSubscriptionTypes = async () => {
    try {
        const response = await api.get('subscriptionType');
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar tipos de assinatura:", error);
        return [];
    }
};